var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.259269 8.04353C-0.0411087 7.7314 -0.0411088 7.22534 0.259268 6.91321L6.68695 0.234095C6.98733 -0.0780316 7.47434 -0.0780319 7.77472 0.234095C8.07509 0.546222 8.07509 1.05228 7.77472 1.36441L1.34703 8.04353C1.04665 8.35565 0.559646 8.35565 0.259269 8.04353Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.225283 6.95648C0.52566 6.64435 1.01267 6.64435 1.31305 6.95648L7.74073 13.6356C8.04111 13.9477 8.04111 14.4538 7.74073 14.7659C7.44035 15.078 6.95335 15.078 6.65297 14.7659L0.225283 8.08679C-0.0750942 7.77466 -0.0750944 7.2686 0.225283 6.95648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.b581d93d4b92a23ce17700ce286348e4.svg";
export { ForwardRef as ReactComponent };